// Shared styles for admin form components (used by organizations, properties, etc.)
import { StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

export const sharedFormStyles = StyleSheet.create({
  // Container
  container: {
    flex: 1,
  },
  
  // Section styles
  section: {
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT.PRIMARY,
    marginBottom: 12,
  },
  sectionSubtitle: {
    fontSize: 13,
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 16,
  },
  
  // Field styles
  field: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.SECONDARY,
    marginBottom: 8,
  },
  
  // Input styles
  input: {
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    borderRadius: 8,
    padding: 12,
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.PRIMARY,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  inputError: {
    borderColor: '#F87171',
  },
  
  // Text styles
  errorText: {
    color: '#F87171',
    fontSize: 12,
    marginTop: 4,
  },
  helpText: {
    color: ADMIN_COLORS.TEXT.PRIMARY,
    fontSize: 12,
    marginTop: 4,
  },
  
  // Button container
  actionsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 24,
    gap: 12,
  },
  
  // Base button
  button: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
    minWidth: 120,
  },
  
  // Button variants
  cancelButton: {
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  cancelButtonText: {
    color: ADMIN_COLORS.TEXT.PRIMARY,
    fontSize: 14,
    fontWeight: '600',
  },
  createButton: {
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
  },
  createButtonText: {
    color: ADMIN_COLORS.BUTTON.PRIMARY_TEXT,
    fontSize: 14,
    fontWeight: '600',
  },
  saveButton: {
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
  },
  saveButtonText: {
    color: ADMIN_COLORS.BUTTON.PRIMARY_TEXT,
    fontSize: 14,
    fontWeight: '600',
  },
  deleteButton: {
    backgroundColor: '#DC2626',
  },
  deleteButtonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
  disabledButton: {
    opacity: 0.5,
  },
  
  // Loading
  loadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    gap: 12,
  },
  loadingText: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.SECONDARY,
  },
});

